import React, { useContext, useEffect, useState } from 'react';
import posed from 'react-pose';

import { changeUser } from "../../api/apiRequests";
import { modalConsControl } from "../wrappers/modalConsControl";
import { UsersContext } from "../../hooks/wrappers/UsersWrapper";

import ModalNewUser from "./users/ModalNewUser";
import { ToolTip } from "../shared/allToolTips";
import MyInput from '../shared/form/MyInput';
import Loading from "../shared/wait/Loading";

import PieceOfInfo from "../shared/PieceOfInfo";
import trash from "../../media/icons/trash.svg";
import admin from "../../media/icons/admin.svg";
import customer from "../../media/icons/customer.svg";
import email from "../../media/icons/email.svg"
import iconSuper from "../../media/icons/super.svg";
import add from "../../media/icons/add.svg";
import CsvDownloadButton from 'react-json-to-csv'


const ModelDiv = posed.div({
  hoverable: true,
  init: {
    y: 0,
    transition: { duration: 100 }
  },
  hover: {
    y: 15,
    transition: { duration: 100 }
  }
});

const Users = ({ changeModal }) => {
  const { users, refreshUsers, isLoading: isLoadingUsers } = useContext(UsersContext)
  const [filter, setFilter] = useState()
  const [filteredUsers, setFilteredUsers] = useState(users)
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (filter) {
      const filters = filter.split(/-| |\//).map(x => x.toLowerCase())
      setFilteredUsers(users.filter(row => {
        const stringRow = `${row.name} ${row.surname} ${row.passport}`
        return filters.reduce((r, fltr) => {
          if (!stringRow.toLowerCase().includes(fltr)) return false
          return r
        }, true)
      }))
    } else setFilteredUsers(users)
  }, [filter, users])// eslint-disable-line

  const deleteUser = (id) => {
    changeUser(id, { active: false }).then(() => {
      refreshUsers();
      alert("El usuario se ha eliminado del sistema")
    }).catch(() => {
      alert("No se ha podido eliminar el usuario")
    })
  };

  const changeRole = (id, role) => {
    changeUser(id, { role }).then(() => {
      refreshUsers();
      alert("Se ha cambiado el rol a " + role)
    }).catch(() => {
      alert("No se ha podido cambiar el rol del usuario")
    })
  };

  const openModalClient = () =>
    changeModal(<ModalNewUser changeModal={changeModal} refreshUsers={refreshUsers} employee={false}/>)

  const openModalEmployee = () =>
    changeModal(<ModalNewUser changeModal={changeModal} refreshUsers={refreshUsers} employee={true}/>)


  if (isLoadingUsers) return <Loading text="Cargando usuarios..."/>


  const usersEmployees = [];
  const usersClients = [];

  filteredUsers.forEach(user => {
    if (user.role === "super" || user.role === "admin") {
      usersEmployees.push(user)
    } else {
      usersClients.push(user)
    }
  });

  const lastIndexPagination = page * 10
  const firstIndexPagination = lastIndexPagination - 10
  const paginatedUsers = usersClients.slice(firstIndexPagination, lastIndexPagination)

  const cleanEmployees = usersEmployees.map(({ bookings, password, ...u }) => u)
  const cleanClients = usersClients.map(({ bookings, password, ...u }) => u)

  console.log(cleanEmployees)

  return (
    <React.Fragment>
      <ToolTip.DeleteUser/>
      <ToolTip.ChangeUserRole/>
      <ToolTip.SendEmail/>
      <ToolTip.MoreClients/>
      <ToolTip.MoreEmployees/>
      <div className="container-fluid py-4">
        <div className="row justify-content-center">
          <ModelDiv data-tip={true} data-for='moreEmployees' style={{ cursor: "pointer", minHeight: "388px" }}
                    onClick={openModalEmployee}
                    className="col-auto m-2 border border-primary">
            <div style={{ maxWidth: "250px", width: "500px" }} className="row h-100 justify-content-center">
              <div className="container-fluid h-100 text-primary bg-white">
                <div className="row justify-content-center align-items-center h-75">
                  <img style={{ opacity: 0.9 }} src={add} alt=""/>
                </div>
                <div className="row justify-content-center align-items-center h-25 ff-bobby text-primary"
                     style={{ fontSize: "30px" }}>
                  EMPLEADO
                </div>
              </div>
            </div>
          </ModelDiv>
          <ModelDiv data-tip={true} data-for='moreClients' style={{ cursor: "pointer", minHeight: "388px" }}
                    onClick={openModalClient}
                    className="col-auto m-2 border border-primary">
            <div style={{ maxWidth: "250px", width: "500px" }} className="row h-100 justify-content-center">
              <div className="container-fluid h-100 text-primary bg-white">
                <div className="row justify-content-center align-items-center h-75">
                  <img style={{ opacity: 0.9 }} src={add} alt=""/>
                </div>
                <div className="row justify-content-center align-items-center h-25 ff-bobby text-primary"
                     style={{ fontSize: "30px" }}>
                  CLIENTE
                </div>
              </div>
            </div>
          </ModelDiv>
        </div>
      </div>
      <div className="container-fluid py-4">

        <div className='row'>
          <div className="col-12 col-lg-6">
            <MyInput title="Seachbar" type="text" value={filter} onChange={(e) => {
              setFilter(e.target.value)
              setPage(1)
            }}/>
          </div>
        </div>

        {usersEmployees?.length > 0 && (
          <PieceOfInfo title="EMPLEADOS">
            <div className="d-flex justify-content-end w-100">
              <CsvDownloadButton data={cleanEmployees} filename="empleados.csv"
                                 className="btn btn-primary btn-sm">
                Descargar CSV
              </CsvDownloadButton>
            </div>
          </PieceOfInfo>
        )}
        {usersEmployees.map((user, key) =>
          <PieceOfInfo key={key} className={key === usersEmployees.length - 1 ? "mb-5" : ''}
                       title={getTextFromUser(user)}>
            <div className="d-flex w-100 justify-content-end">
              <a rel="noopener noreferrer" target="_blank" href={"mailto:" + user.email} className="d-flex">
                <img data-tip={user.email} data-for='sendEmail' src={email} style={{ cursor: "pointer" }} width="20px"
                     height="20px" className="mr-3" alt=""/>
              </a>
              <img data-tip={"Super"} data-for='changeUserRole' onClick={() => changeRole(user._id, "super")}
                   style={{ cursor: "pointer", opacity: (user.role === "super" ? 1 : 0.5) }} width="20px" height="20px"
                   src={iconSuper} alt=""/>
              <img data-tip={"Admin"} data-for='changeUserRole' onClick={() => changeRole(user._id, "admin")}
                   style={{ cursor: "pointer", opacity: (user.role === "admin" ? 1 : 0.5) }} width="20px" height="20px"
                   src={admin} alt=""/>
              <img data-tip={"Cliente"} data-for='changeUserRole' onClick={() => changeRole(user._id, "customer")}
                   style={{ cursor: "pointer", opacity: 0.5 }} width="20px"
                   height="20px"
                   src={customer} alt=""/>
              <img data-tip={true} data-for='deleteUser' onClick={() => deleteUser(user._id)}
                   style={{ cursor: "pointer" }} width="20px" height="20px"
                   src={trash} alt=""/>
            </div>
          </PieceOfInfo>
        )}

        {paginatedUsers?.length > 0 && (
          <PieceOfInfo title="CLIENTES">
            <div className="d-flex justify-content-end w-100">
              <CsvDownloadButton data={cleanClients} filename="clientes.csv"
                                 className="btn btn-primary btn-sm">
                Descargar CSV
              </CsvDownloadButton>
            </div>
          </PieceOfInfo>
        )}
        {paginatedUsers.map((user, key) =>
          <PieceOfInfo key={key} title={getTextFromUser(user)}>
            <div className="d-flex w-100 justify-content-end">
              <a rel="noopener noreferrer" target="_blank" href={"mailto:" + user.email} className="d-flex">
                <img data-tip={user.email} data-for='sendEmail' src={email} style={{ cursor: "pointer" }} width="20px"
                     height="20px" className="mr-3" alt=""/>
              </a>
              <img data-tip={"Super"} data-for='changeUserRole' onClick={() => changeRole(user._id, "super")}
                   style={{ cursor: "pointer", opacity: 0.5 }} width="20px" height="20px"
                   src={iconSuper} alt=""/>
              <img data-tip={"Admin"} data-for='changeUserRole' onClick={() => changeRole(user._id, "admin")}
                   style={{ cursor: "pointer", opacity: 0.5 }} width="20px" height="20px"
                   src={admin} alt=""/>
              <img data-tip={"Cliente"} data-for='changeUserRole' onClick={() => changeRole(user._id, "customer")}
                   style={{ cursor: "pointer" }} width="20px"
                   height="20px"
                   src={customer} alt=""/>
              <img data-tip={true} data-for='deleteUser' onClick={() => deleteUser(user._id)}
                   style={{ cursor: "pointer" }} width="20px" height="20px"
                   src={trash} alt=""/>
            </div>
          </PieceOfInfo>
        )}
        <div className="d-flex justify-content-center py-4" style={{ gap: "1rem" }}>
          <button className="btn btn-primary px-4" disabled={page <= 1}
                  onClick={() => setPage((c) => c - 1)}>
            Anterior
          </button>
          <button className="btn btn-primary px-4" disabled={lastIndexPagination >= usersClients.length}
                  onClick={() => setPage((c) => c + 1)}>
            Siguiente
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

const getTextFromUser = ({ passport, name, surname, bookings }) =>
  passport + " -> " + name + (surname ? ` ${surname}` : '') + " -> Reservas: " + (bookings.filter(booking => (booking.active === true && booking.status !== "canceled")).length)

export default modalConsControl(Users);
